import type { Folder } from '../types';

export type FolderNode = Folder & { children: FolderNode[] };

export function buildFolderTree(folders: Folder[]): FolderNode[] {
  const map = new Map<string, FolderNode>();
  const roots: FolderNode[] = [];

  folders.forEach((f) => {
    map.set(f.id, { ...f, children: [] });
  });

  Array.from(map.values()).forEach((node) => {
    const parent = node.parentId ? map.get(node.parentId) : null;
    if (parent) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  });

  // Roll up descendant counts into each parent
  const rollUp = (node: FolderNode): number => {
    const childTotal = node.children.reduce((sum, child) => sum + rollUp(child), 0);
    node.assetCount += childTotal;
    return node.assetCount;
  };
  roots.forEach(rollUp);

  return roots;
}

/** Flatten a folder tree into select-friendly options with depth for indentation */
export function flattenFolderTree(nodes: FolderNode[], depth = 0): { id: string; name: string; depth: number }[] {
  const result: { id: string; name: string; depth: number }[] = [];
  nodes.forEach((node) => {
    result.push({ id: node.id, name: node.name, depth });
    result.push(...flattenFolderTree(node.children, depth + 1));
  });
  return result;
}
